import { z } from 'zod';

// 8-colour palette for stage badges across the platform (topbar pill,
// Builds list, milestone displays). Stored as a lowercase string in the
// DB; the portal maps to Tailwind / hex values at render time.
export const StageColourSchema = z.enum([
  'gray',
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'purple',
  'pink',
]);
export type StageColour = z.infer<typeof StageColourSchema>;

export const STAGE_COLOUR_ORDER: readonly StageColour[] = [
  'gray',
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'purple',
  'pink',
] as const;

// Fixed taxonomy that the AI calibration layer consumes. The user-facing
// stage label is whatever the dev typed; the tier tells the AI where in
// the lifecycle the stage sits regardless of the label.
export const SemanticTierSchema = z.enum(['early', 'mid', 'live']);
export type SemanticTier = z.infer<typeof SemanticTierSchema>;

export const SEMANTIC_TIER_LABELS: Readonly<Record<SemanticTier, string>> = {
  early: 'Early',
  mid: 'Mid',
  live: 'Live',
};

export const GameDevStageSchema = z.object({
  id: z.string().uuid(),
  gameId: z.string().uuid(),
  label: z.string().min(1),
  colour: StageColourSchema,
  semanticTier: SemanticTierSchema,
  orderIndex: z.number().int().nonnegative(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type GameDevStage = z.infer<typeof GameDevStageSchema>;
